import { Box, Grid } from '@material-ui/core';
import React, { memo } from 'react';
import clsx from 'clsx';
import useStyles from './style';

interface ISelectOption {
  id: string,
  text: string,
}
interface IDesiredStoreOptions {
  title?:string,
  list: ISelectOption[],
  defaultOption: string,
  disabled?: boolean,
  isRequired?: boolean,
  handleClick?: (val:string, name: string) => void
}
const DesiredStoreOptions : React.FC<IDesiredStoreOptions> = ({
  title, list = [], defaultOption, disabled = false, isRequired = false, handleClick,
}) => {
  const classes = useStyles();
  const handleChange = (id:string, text:string) => {
    if (isRequired && id === defaultOption) {
      return;
    }
    handleClick && handleClick(id === defaultOption ? '' : id, id === defaultOption ? '' : text);
  };
  return (
    <Box className={classes.desiredStoreOptionsRoot}>
      <p className={classes.optionsTitle}>{title || ''}</p>
      <Grid container={true} className={classes.optionStoreContainer}>
        {list?.length > 0 && list?.map((item:ISelectOption, index) => (
          <Box key={item?.id || index} onClick={() => handleChange(item?.id, item?.text)}>
            <div className={clsx(classes.optionStore, { [classes.optionStoreActive]: (defaultOption === item?.id) })}>
              <span>{item?.text || ''}</span>
            </div>
          </Box>
        ))}
      </Grid>
    </Box>
  );
};


export default memo(DesiredStoreOptions);
